module.exports = __webpack_public_path__ + "static/media/grin-tears.a92b670b.svg";